import { useEffect, useState } from "react"
import { useDispatch, useSelector, useStore } from "react-redux";


import { setIsPlaying } from "../../actions/isplaying"
import { set_song } from "../../actions/song";

import { PREVSONG, NEXTSONG, PLAY, PAUSE, REPEAT, REPEATSONG } from "../../constants/action_types";
import { prev_song, next_song } from "../../actions/currentalbum";

import useStyles from "./styles.js";

import formatTime from "./formattime/formattime.js";

import Song from "./song/song.js";
import Trackbar from "./trackbar/trackbar.js";
import { toggleRepeat } from "../../actions/togglerepeat";

const Audio = () =>
{

  const dispatch = useDispatch();

  /**
   * I should probably stick to using only useSelector or useStore
   * in the future
   */

  const store = useStore();

  const classes = useStyles();

  /**
   * Using refs can get highly messy so annotating this here
   * music_player is a ref to the main dom audio player
   */
  let music_player;

  const [totalTime, setTotalTime] = useState(0);
  const [currentTime, setCurrentTime] = useState(0);

  // Is song currently playing
  const playing = useSelector((state) => state.isplaying);
  // Is repeat song toggled
  const repeat = useSelector((state) => state.repeat);

  /**
   * Logic for handling clicks on bar
   */
  const [clickedTime, setClickedTime] = useState();

  useEffect(() =>
  {
    if (isNaN(clickedTime)) return;
    music_player.currentTime = clickedTime;
  }, [clickedTime, music_player])

  const afterUpdate = () =>
  {
    let current_data = store.getState().current;
    let song = current_data.album.songs[current_data.song_index];
    dispatch(set_song(song));
  }

  const repeatSong = () =>
  {
    music_player.currentTime = 0;
    music_player.play();
  }

  const handle_click = (action_type) =>
  {
    if (!music_player) return console.log("Choose a song before trying to play it.");

    switch (action_type)
    {
      case PLAY:
        music_player.play();
        dispatch(setIsPlaying(!playing));
        break;
      case PAUSE:
        music_player.pause();
        dispatch(setIsPlaying(!playing));
        break;
      case PREVSONG:
        dispatch(prev_song(PREVSONG));
        dispatch(setIsPlaying(true));
        break;
      case NEXTSONG:
        dispatch(next_song(NEXTSONG));
        dispatch(setIsPlaying(true));
        break;
      case REPEAT:
        dispatch(toggleRepeat(REPEAT));
        break;
      case REPEATSONG:
        repeatSong();
        break;
      default:
        return console.log("Unknown action type\nIf this happened something's either gone horribly wrong or you know what you're doing and are fucking with the console");
    }
    afterUpdate();
  }


  navigator.mediaSession.setActionHandler("play", () => handle_click(PLAY));
  navigator.mediaSession.setActionHandler("pause", () => handle_click(PAUSE));
  navigator.mediaSession.setActionHandler("previoustrack", () => handle_click(PREVSONG));
  navigator.mediaSession.setActionHandler("nexttrack", () => handle_click(NEXTSONG));

  const current_song = useSelector((state) => state.song);

  return (
    <div className={classes.audio_bar}>
      {
        current_song._id
          ? (
            <div>
              <Song song={current_song} />
              <button onClick={() => handle_click(PREVSONG)}>
                Prev
              </button>
              {playing ?
                (
                  <button onClick={() => handle_click(PAUSE)}>
                    Pause
                  </button>
                )
                : (
                  <button onClick={() => handle_click(PLAY)}>
                    Play
                  </button>
                )}
              <button onClick={() => handle_click(NEXTSONG)}>
                Next
              </button>
              {repeat ?
                (
                  <button onClick={() => handle_click(REPEAT)}>
                    Stop Repeat
                  </button>
                )
                : (
                  <button onClick={() => handle_click(REPEAT)}>
                    Repeat
                  </button>
                )
              }

              <audio
                autoPlay src={current_song.songUrl}
                onPlay={(e) => setTotalTime(e.target.duration)}
                onTimeUpdate={(e) => setCurrentTime(e.target.currentTime)}
                onEnded={repeat ? () => handle_click(REPEATSONG) : () => handle_click(NEXTSONG)}
                ref={ref => music_player = ref}
              />

              <div>
                {formatTime(currentTime)} / {formatTime(totalTime)}
              </div>

              <input
                type="range"
                min="0"
                max="100"
                step="1"
                defaultValue="100"
                onChange={(evt) => music_player.volume = (evt.target.value / 100)}
              />

              <Trackbar
                currentTime={currentTime}
                totalTime={totalTime}
                music_player={music_player}
                onTimeUpdate={(time) => setClickedTime(time)}
              />



            </div>
          )
          : (
            <div>
              Nothing playing right now
            </div>
          )}
    </div>
  );
}

export default Audio;
